var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29367 3.96556C3.62685 5.90311 2.29344 6.87189 1.76974 8.30291C1.72773 8.41771 1.68994 8.534 1.65645 8.65157C1.23901 10.1171 1.74832 11.6846 2.76696 14.8197C3.78559 17.9547 4.2949 19.5222 5.49405 20.4625C5.59025 20.5379 5.68918 20.6098 5.79064 20.678C7.05546 21.5279 8.70364 21.5279 12 21.5279C15.2964 21.5279 16.9446 21.5279 18.2094 20.678C18.3108 20.6098 18.4098 20.5379 18.506 20.4625C19.7051 19.5222 20.2144 17.9547 21.2331 14.8197C22.2517 11.6846 22.761 10.1171 22.3436 8.65157C22.3101 8.534 22.2723 8.41771 22.2303 8.30291C21.7066 6.87189 20.3732 5.90312 17.7064 3.96557C15.0395 2.02801 13.7061 1.05923 12.1833 1.00336C12.0611 0.99888 11.9389 0.99888 11.8167 1.00336C10.2939 1.05923 8.96048 2.02801 6.29367 3.96556ZM10 16.0697C9.58579 16.0697 9.25 16.4054 9.25 16.8197C9.25 17.2339 9.58579 17.5697 10 17.5697H14C14.4142 17.5697 14.75 17.2339 14.75 16.8197C14.75 16.4054 14.4142 16.0697 14 16.0697H10Z",
    stroke: "#898793",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeInactive);
export default __webpack_public_path__ + "static/media/home_inactive.efa526264140323e9597b4f1a3d769fd.svg";
export { ForwardRef as ReactComponent };